
export default function PrivacyContent() {
  return (
    <article className="max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-8 pb-4 border-b border-neutral-200">
        <div className="w-10 h-10 flex items-center justify-center bg-neutral-900 text-white rounded-lg">
          <i className="ri-shield-check-line text-lg"></i>
        </div>
        <div>
          <h2 className="text-xl font-bold text-neutral-900" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
            Política de Privacidad
          </h2>
          <p className="text-xs text-neutral-500">Última actualización: Enero 2025</p>
        </div>
      </div>

      <div className="space-y-8 text-neutral-700 text-sm leading-relaxed">
        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#responsable" className="hover:text-amber-600 transition-colors">1. Responsable del Tratamiento</a>
          </h4>
          <p>
            En cumplimiento del <strong>Reglamento General de Protección de Datos (RGPD) UE 2016/679</strong> y la <strong>Ley Orgánica 3/2018 de Protección de Datos Personales y Garantía de los Derechos Digitales (LOPDGDD)</strong>, le informamos que el responsable del tratamiento de sus datos personales es:
          </p>
          <div className="mt-4 bg-neutral-50 border border-neutral-200 rounded-lg p-5 space-y-2">
            <p><strong>Titular:</strong> Daro Tattoo</p>
            <p><strong>Actividad:</strong> Estudio profesional de tatuajes y arte urbano</p>
            <p><strong>Ubicación:</strong> Adra, Almería, España</p>
            <p><strong>Email de contacto:</strong> info@darotattoo.com</p>
          </div>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#datos" className="hover:text-amber-600 transition-colors">2. Datos que Recopilamos</a>
          </h4>
          <p className="mb-3">Recopilamos los datos personales que usted nos proporciona voluntariamente a través de nuestros formularios:</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-line text-amber-600 mt-0.5 shrink-0"></i>
              <span><strong>Datos identificativos:</strong> nombre completo, edad, email y teléfono</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-line text-amber-600 mt-0.5 shrink-0"></i>
              <span><strong>Datos de la solicitud:</strong> estilo de tatuaje deseado, tamaño, zona del cuerpo, descripción de la idea y referencias visuales</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-line text-amber-600 mt-0.5 shrink-0"></i>
              <span><strong>Datos de disponibilidad:</strong> días y horarios preferidos para la cita</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-checkbox-circle-line text-amber-600 mt-0.5 shrink-0"></i>
              <span><strong>Datos de suscripción:</strong> dirección de correo electrónico para newsletter</span>
            </li>
          </ul>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#finalidad" className="hover:text-amber-600 transition-colors">3. Finalidad del Tratamiento</a>
          </h4>
          <p className="mb-3">Sus datos personales serán tratados con las siguientes finalidades:</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {[
              { icon: 'ri-calendar-check-line', text: 'Gestionar solicitudes de citas y reservas de tatuajes' },
              { icon: 'ri-mail-send-line', text: 'Enviar comunicaciones relacionadas con su solicitud' },
              { icon: 'ri-megaphone-line', text: 'Enviar newsletter con novedades y promociones (solo con consentimiento)' },
              { icon: 'ri-customer-service-2-line', text: 'Atender consultas y solicitudes de información' },
              { icon: 'ri-bar-chart-line', text: 'Mejorar nuestros servicios y experiencia del usuario' },
              { icon: 'ri-file-text-line', text: 'Cumplir con obligaciones legales y fiscales aplicables' },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3 bg-neutral-50 rounded-lg p-3 border border-neutral-100">
                <div className="w-8 h-8 flex items-center justify-center bg-neutral-900 text-white rounded shrink-0">
                  <i className={`${item.icon} text-sm`}></i>
                </div>
                <span className="text-sm">{item.text}</span>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#legitimacion" className="hover:text-amber-600 transition-colors">4. Base Legal del Tratamiento</a>
          </h4>
          <p>La base legal para el tratamiento de sus datos es:</p>
          <ul className="mt-3 space-y-2 ml-4">
            <li className="flex items-start gap-2">
              <i className="ri-arrow-right-s-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span><strong>Consentimiento del interesado</strong> (Art. 6.1.a RGPD): al completar nuestros formularios y aceptar esta política</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-arrow-right-s-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span><strong>Ejecución de un contrato</strong> (Art. 6.1.b RGPD): para la gestión de citas y prestación de servicios</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-arrow-right-s-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span><strong>Interés legítimo</strong> (Art. 6.1.f RGPD): para mejorar nuestros servicios</span>
            </li>
          </ul>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#conservacion" className="hover:text-amber-600 transition-colors">5. Conservación de Datos</a>
          </h4>
          <p>
            Sus datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron recogidos. Los datos de clientes se conservarán mientras dure la relación comercial y, posteriormente, durante los plazos legalmente establecidos para atender posibles responsabilidades (mínimo 5 años según normativa fiscal).
          </p>
          <p className="mt-3">
            Los datos de suscripción a newsletter se conservarán hasta que solicite su baja.
          </p>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#derechos" className="hover:text-amber-600 transition-colors">6. Derechos del Usuario</a>
          </h4>
          <p className="mb-3">Usted tiene derecho a:</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {[
              'Acceder a sus datos personales',
              'Rectificar datos inexactos o incompletos',
              'Solicitar la supresión de sus datos',
              'Oponerse al tratamiento de sus datos',
              'Solicitar la limitación del tratamiento',
              'Portabilidad de sus datos',
            ].map((right, i) => (
              <div key={i} className="flex items-center gap-2 py-2 px-3 bg-neutral-50 rounded border border-neutral-100">
                <i className="ri-check-line text-amber-600 shrink-0"></i>
                <span className="text-sm">{right}</span>
              </div>
            ))}
          </div>
          <p className="mt-4 text-neutral-500 text-xs">
            Para ejercer estos derechos, puede contactarnos en <strong>info@darotattoo.com</strong>. También tiene derecho a presentar una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong> en <a href="https://www.aepd.es" target="_blank" rel="nofollow noopener noreferrer" className="underline hover:text-neutral-700 cursor-pointer">www.aepd.es</a>.
          </p>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#cookies" className="hover:text-amber-600 transition-colors">7. Cookies</a>
          </h4>
          <p>
            Este sitio web puede utilizar cookies técnicas y analíticas para garantizar su correcto funcionamiento y mejorar la experiencia del usuario. Las cookies técnicas son necesarias para la navegación y no requieren consentimiento. Las cookies analíticas, en caso de utilizarse, solo se activarán con su consentimiento previo.
          </p>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#seguridad" className="hover:text-amber-600 transition-colors">8. Seguridad</a>
          </h4>
          <p>
            Hemos adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de sus datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, conforme al estado de la tecnología y la naturaleza de los datos almacenados.
          </p>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#menores" className="hover:text-amber-600 transition-colors">9. Menores de Edad</a>
          </h4>
          <p>
            Nuestros servicios de tatuaje están dirigidos exclusivamente a <strong>mayores de 18 años</strong>. No recopilamos conscientemente datos de menores de edad. Si detectamos que hemos recogido datos de un menor, procederemos a su eliminación inmediata.
          </p>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#modificaciones" className="hover:text-amber-600 transition-colors">10. Modificaciones</a>
          </h4>
          <p>
            Nos reservamos el derecho a modificar esta política de privacidad para adaptarla a novedades legislativas o jurisprudenciales. En caso de cambios significativos, se lo notificaremos a través de nuestra web.
          </p>
        </section>
      </div>
    </article>
  );
}
